module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle)
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v(_vm._s(_vm.classroom))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a08ebf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/TimelineHeader.vue
// module id = 690
// module chunks = 0